import cn from 'classnames';
import type { FC, ReactNode } from 'react';
import * as st from './Description.module.scss';

interface Props {
  title: string | number;
  svg?: ReactNode;
  size: 'large' | 'small';
}

const Description: FC<Props> = ({ title, svg, size }) => {
  return (
    <div
      className={cn(st.wrapper, (size === 'small' && st.small) || (size === 'large' && st.large))}
    >
      {svg && <div className={st.svg}>{svg}</div>}
      <p>{title}</p>
    </div>
  );
};

export default Description;
